import * as DashboardConstants from '.././DashboardConstants';

export const breakfixTableHeaders = [
    {
        key: 'severity',
        header: 'Process name'
    },
    {
        key: 'total',
        header: 'No of items'
    },
    {
        key: 'New',
        header: 'Completed'
    },
    {
        key: 'In Progress',
        header: 'Pending'
    },
    {
        key: 'Resolved',
        header: 'Running'
    },
    {
        key: 'On Hold',
        header: 'Business Ex.'
    },
    {
        key: 'Closed',
        header: 'System Ex.'
    },
    {
        key: 'Closed',
        header: 'Bot accuracy.'
    }
];
export const breakfixTableData = [
    {
        id: 1,
        severity: '1-Critical',
        total: 1000,
        New: 20,
        "In Progress": 300,
        Resolved: 30,
        onHold: 40,
        closed: 200
    },
    {
        id: 2,
        severity: '2-High',
        total: 1000,
        new: 20,
        inProgress: 300,
        resolved: 30,
        onHold: 40,
        closed: 200
    },
    {
        id: 3,
        severity: '3-Moderate',
        total: 1000,
        new: 20,
        inProgress: 300,
        resolved: 30,
        onHold: 40,
        closed: 200
    }
]
export const severityWiseTableHeaders = [
    {
        key: 'item',
        header: 'Incident Status'
    },
    {
        key: 'count',
        header: 'Count'
    }
];
export const severityWiseTableData = [
    {
        id: 1,
        status: 'New',
        count: 20
    },
    {
        id: 2,
        status: 'In-Pogress',
        count: 30
    }
]
export const reopenCountTableHeaders = [
    {
        key: 'item',
        header: 'Priority'
    },
    {
        key: 'total',
        header: 'Total'
    },
    {
        key: 'reOpenCount',
        header: 'Re-open count'
    },
    {
        key: 'percentage',
        header: '%First Time Resolve.'
    }
];

export const reopenCountTableData = [
    {
        id: 1,
        priority: 'P1',
        total: 100,
        count: 20,
        percentage: '100%'
    },
    {
        id: 2,
        priority: 'P2',
        total: 100,
        count: 20,
        percentage: '100%'
    },
    {
        id: 3,
        priority: 'P1',
        total: 100,
        count: 20,
        percentage: '100%'
    }
]
export const incidentAgingTableHeaders = [
    {
        key: 'item',
        header: 'Priority'
    },
    {
        key: 'total',
        header: 'Total tickets'
    },
    {
        key: 'days',
        header: 'Avg Aging (Days)'
    },
];

export const incidentAgingTabledata = [
    {
        id: 1,
        priority: 'P1',
        total: 280,
        days: 140
    },
    {
        id: 2,
        priority: 'P2',
        total: 280,
        days: 140
    },
    {
        id: 3,
        priority: 'P3',
        total: 280,
        days: 140
    }
]


export const performanceTrendHeaders = [
    {
        key: 'ProcessName',
        header: DashboardConstants.AutomataName
    },
    // {
    //     key: 'queueName',
    //     header: DashboardConstants.QueueName
    // },
    {
        key: 'NoofItem',
        header: DashboardConstants.NoOfItems
    },
    {
        key: 'CompletedItem',
        header: DashboardConstants.Completed
    },
    {
        key: 'ItemPending',
        header: DashboardConstants.Pending
    },
    {
        key: 'running',
        header: DashboardConstants.Running
    },
    {
        key: 'BusinessException',
        header: DashboardConstants.BusinessEx
    },
    {
        key: 'SystemException',
        header: DashboardConstants.SystemEx
    },
    // {
    //     key: 'dFTE',
    //     header: DashboardConstants.dFTE
    // },
    // {
    //     key: 'Speed',
    //     header: DashboardConstants.Speed
    // },
    // {
    //     key: 'UPT',
    //     header: DashboardConstants.UPT
    // },
    {
        key: 'Others',
        header: DashboardConstants.Others
    },
    {
        key: 'botaccuracy',
        header: DashboardConstants.AutomataAccuracy
    }

]

export const queuePerformanceHeaders = [
    {
        key: 'QueueName',
        header: DashboardConstants.QueueName
    },
    {
        key: 'Avgretries',
        header: DashboardConstants.AverageRetries
    },
    {
        key: 'AvgHandlingTime',
        header: DashboardConstants.AvgHandlingTimeMin
    },
    {
        key: 'AvgProcessTime',
        header: DashboardConstants.AvgProcessingTimeMin
    }
]


export const performanceTrendDownloadableHeaders = [
    {
        key: 'ProcessName',
        header: DashboardConstants.AutomataName
    },
    {
        key: 'queueName',
        header: DashboardConstants.QueueName
    },
    {
        key: 'resourceName',
        header: DashboardConstants.ResourceName
    },
    {
        key: 'NoofItem',
        header: DashboardConstants.NoOfItems
    },
    {
        key: 'CompletedItem',
        header: DashboardConstants.Completed
    },
    {
        key: 'ItemPending',
        header: DashboardConstants.Pending
    },
    {
        key: 'running',
        header: DashboardConstants.Running
    },
    {
        key: 'BusinessException',
        header: DashboardConstants.BusinessEx
    },
    {
        key: 'SystemException',
        header: DashboardConstants.SystemEx
    },
    {
        key: 'dFTE',
        header: 'dFTE'
    },
    {
        key: 'Speed',
        header: 'Speed'
    },
    {
        key: 'UPT',
        header: 'UPT'
    },
    {
        key: 'botaccuracy',
        header: DashboardConstants.AutomataAccuracy
    }

]
